import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  const rankColors: Record<number, string> = {
    1: 'bg-primary-500 text-background-50',
    2: 'bg-primary-400 text-background-50',
    3: 'bg-accent-500 text-background-50',
  };

  const tagColors: Record<string, string> = {
    '热门': 'bg-primary-100 text-primary-700',
    '新锐': 'bg-accent-100 text-accent-700',
    '推荐': 'bg-secondary-100 text-secondary-700',
    '活跃': 'bg-accent-100 text-accent-700',
    '新站': 'bg-secondary-100 text-secondary-700',
  };

  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">站点排行</h2>
          <p className="mt-2 text-sm text-foreground-600">黑料网站热度排行，发现最受欢迎的优质内容站点</p>
        </div>
        <div className="max-w-[800px] mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 bg-background-50 border-b border-background-200 last:border-b-0 first:rounded-t-lg last:rounded-b-lg hover:bg-primary-50/30 transition-colors cursor-pointer"
            >
              <span
                className={`flex-shrink-0 w-8 h-8 flex items-center justify-center text-sm font-bold rounded-lg ${
                  rankColors[item.rank] || 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.name}</h3>
                  <span className={`px-2 py-0.5 text-[10px] font-semibold rounded ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-600 line-clamp-1">{item.description}</p>
              </div>
              <span className="flex-shrink-0 text-xs font-semibold text-primary-600 whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}